document.addEventListener('DOMContentLoaded', () => {
    const rows = document.querySelectorAll<HTMLTableRowElement>('.financial-calendar-table__row');
    rows.forEach(row => {
        const href = row.dataset.href;
        if (!href) return;

        row.addEventListener('click', () => {
            window.location.href = href;
        });
    });
});
